import { defineStore } from "pinia";
import { ref } from "vue";

export type SaveOfferVariant = "cost" | "failed";

export const useSaveOfferModalStore = defineStore("saveOfferModal", () => {
    const isOpen = ref(false);
    const variant = ref<SaveOfferVariant>("cost");

    const open = (v: SaveOfferVariant) => {
        variant.value = v;
        isOpen.value = true;
    };

    const close = () => {
        isOpen.value = false;
    };

    return {
        isOpen,
        variant,
        open,
        close,
    };
});
